import { getYear, isBefore, parseISO } from 'date-fns';

import { ENDLESS_DATE } from './consts';

const endlessDate = parseISO(ENDLESS_DATE);

export const isEndlessBannerDate = (bannerDateString: string): boolean => {
  const bannerDate = parseISO(bannerDateString);
  return isBefore(endlessDate, bannerDate);
};

/**
 * Форматирование даты окончания баннера.
 * Если кончается в текущем году, то год не должен выводиться
 */
export const getBannerEndDate = (bannerDate: string): string => {
  const nowYear = getYear(new Date());
  const yearOfBannerDate = getYear(parseISO(bannerDate));
  if (yearOfBannerDate - nowYear >= 1 && nowYear - yearOfBannerDate < 50) {
    return 'до dd.MM.yy';
  }
  return 'до dd.MM';
};
